import React, { type PropsWithChildren } from 'react';
import { cssMap, cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { fg } from '@atlassian/jira-feature-gating';
import { ADVANCED, type Tabs } from '../../../common/constants.tsx';

const styles = cssMap({
	container: {
		display: 'flex',
		height: '422px',
		width: '600px',
	},
	advancedContainer: {
		width: '480px',
	},
	containerWithTabs: {
		display: 'flex',
		width: '600px',
	},
});

export const FilterPopupContainer = ({
	children,
	isModeSwitcherEnabled = false,
	activeTab,
}: PropsWithChildren<{
	isModeSwitcherEnabled?: boolean;
	activeTab?: Tabs;
}>) => (
	<Box
		xcss={cx(
			isModeSwitcherEnabled && fg('list_lovability_improving_filters')
				? styles.containerWithTabs
				: styles.container,
			isModeSwitcherEnabled &&
				activeTab === ADVANCED &&
				fg('list_lovability_improving_filters') &&
				styles.advancedContainer,
		)}
	>
		{children}
	</Box>
);
